<div class="tabview-list">
  <!--<div [class.active]="tabIndex() === 0" (click)="tabIndex.set(0)"><i class="mdi mdi-wifi"></i> Legacy</div>-->
  <div [class.active]="tabIndex() === 1" (click)="tabIndex.set(1)"><i class="mdi mdi-chart-bar"></i> Areas</div>
  <div></div>
</div>

@switch (tabIndex()) {
  @case (0) {
    @if (noFootfallgateways) {
      <div class="col-md-12 no-footfall-gateways">
        <app-info-panel>
          <p>Your organisation has no footfall devices.</p>
        </app-info-panel>
      </div>
    }

    @if (gateways.length >= 1) {
      <div class="col-md-12">
        <div class="component-list">
          <table class="table table-hover table-sm assets">
            <thead>
              <tr>
                <th>Title</th>
                <th>Location</th>
                <th>Org</th>
              </tr>
            </thead>
            <tbody>
              @for (item of gateways; track item; let i = $index) {
                <tr (click)="selectGateway(item)" [class.selected]="gateway && item.id === gateway.id">
                  <td><app-gateway-indicator [gateway]="item"></app-gateway-indicator> {{ item.title }}</td>
                  <td>{{ item.location }}</td>
                  <td>{{ item.org?.title }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    }
    @if (gateway?.id) {
      <div class="col-md-12 mt-4">
        <div class="row">
          <div class="col-md-3"></div>
          <div class="col-md-6">
            @if (this.timerSubscription) {
              <p class="text-center" title="People in and out since showing this page"><i class="fa fa-refresh fa-spin"></i> Monitoring footfall from {{ now | amTimeAgo }}</p>
            }
          </div>
        </div>
        <!-- TESTING <button class="btn btn-sm" (click)="use('redis')">REDIS {{useThis==='redis'?'X':''}}</button>
        <button class="btn btn-sm" (click)="use('sql')">SQL {{useThis==='sql'?'X':''}}</button> -->
        @for (item of charts; track item; let i = $index) {
          <div class="row chart-row">
            <div class="col-md-12">
              @if (data.datasets[i].data.length) {
                <p-chart data-id="{{ item.id }}" name="chart" #chart type="bar" [data]="data" [options]="options"></p-chart>
              }
            </div>
          </div>
        }
      </div>
    }
    @if (asset.id) {
      <div class="col-12 mt-2"></div>
    }

    @if (asset.id) {
      <div class="col-md-6 count col-sm-6 col-xs-6 counter">
        <p class="text-center">In</p>
        <p class="text-center">{{ count.in }}</p>
      </div>
    }
    @if (asset.id) {
      <div class="col-md-6 count col-sm-6 col-xs-6 counter">
        <p class="text-center">Out</p>
        <p class="text-center">{{ count.out }}</p>
      </div>
    }
    @if (asset.id && subdomain !== 'public') {
      <div class="col-md-12 info">
        <div class="row">
          <div class="col-md-12">
            <h2>Footfall process</h2>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <img src="assets/4dmotion_640.png" class="img-responsive" />
          </div>
          <div class="col-md-6">
            <p>As a person walks past the 4D footfall gateway (as seen in the white ipad) the software running on the 4D footfall gateway tracks the person (as seen on the black windows tablet).</p>
            <p>As the person walks in or out, the 4D footfall gateway transmits the amount of people back to the 4D platform.</p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 mt-2">
            <p>The chart shows these values in realtime as people move past the 4D footfall gateway.</p>
            <p>The In and Out totals show the total counts since displaying this page.</p>
          </div>
          <div class="col-md-6 mt-2">
            <img src="assets/4dmotion_chart_640.png" class="img-responsive" />
          </div>
        </div>
      </div>
    }
  }
  @default {
    <app-foorfall-areas></app-foorfall-areas>
  }
}
